/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RecourseBookingCudto } from '../../models/recourse-booking-cudto';
import { RecourseBookingDto } from '../../models/recourse-booking-dto';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface UpdateRecourseBookingDetails$Params {
  recourseBookingId: number;
  body: RecourseBookingCudto;
}

export function updateRecourseBookingDetails(
  http: HttpClient,
  rootUrl: string,
  params: UpdateRecourseBookingDetails$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<RecourseBookingDto>> {
  const rb = new RequestBuilder(rootUrl, updateRecourseBookingDetails.PATH, 'put');
  if (params) {
    rb.path('recourseBookingId', params.recourseBookingId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RecourseBookingDto>;
    }),
  );
}

updateRecourseBookingDetails.PATH = '/service/v1/recoursebooking/{recourseBookingId}';
